import React, { RefObject, forwardRef } from "react";
import styles from "./blueprint-table-with-spinner.module.scss";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import Spinner from "@src/components/atoms/spinner/spinner";
import { BlueprintTable } from "../blueprint-table/blueprint-table";

const cssClassName = "blueprint-table-with-spinner";

interface BlueprintTableWithSpinnerPropTypes {
  loadingBlueprintsList: boolean;
  suggestedBlueprintsArray: BlueprintsArrayObjectTypes[];
  activeBlueprint?: BlueprintsArrayObjectTypes;
  setPopoverPosition: (coordinates: { x: number; y: number }) => void;
  setActiveBlueprint: (blueprint: BlueprintsArrayObjectTypes) => void;
  setActivePopover: (blueprint: BlueprintsArrayObjectTypes) => void;
}

export const BlueprintTableWithSpinner = forwardRef(
  (
    {
      loadingBlueprintsList,
      suggestedBlueprintsArray,
      activeBlueprint,
      setPopoverPosition,
      setActiveBlueprint,
      setActivePopover,
    }: BlueprintTableWithSpinnerPropTypes,
    ref: RefObject<HTMLDivElement>,
  ) => {
    return (
      <div className={styles[cssClassName]}>
        {loadingBlueprintsList ? (
          <Spinner />
        ) : (
          <BlueprintTable
            ref={ref}
            blueprintArray={suggestedBlueprintsArray}
            activeBlueprint={activeBlueprint}
            popoverPositionCallback={setPopoverPosition}
            activeBlueprintCallback={setActiveBlueprint}
            activePopoverCallback={setActivePopover}
          />
        )}
      </div>
    );
  },
);
BlueprintTableWithSpinner.displayName = "BlueprintTableWithSpinner";
